import Contact from "./components/contact/Contact"
import Footer from "./components/footer/Footer"
import Results from "./components/results/Results"
import {BrowserRouter, Route, Routes, Navigate} from "react-router-dom";
import Navbar2 from "./components/navbar/Navbar2.jsx";
import Home from "./components/home/Home.jsx";
import Contratar from "./components/contratar/Contratar.jsx";
import CalculadorMacros from "./pages/CalculadorMacros.jsx";
import CambioForm from "./components/contact/CambioForm.jsx";
import PlanParaTi from "./components/plan/PlanParaTi.jsx";
import QuieresEmpezar from "./components/cta/QuieresEmpezar.jsx";
import {lazy, Suspense} from "react";

const AdminApp = lazy(() => import("../admin/AdminApp.jsx"));
const IntakePage = lazy(() => import("../public/IntakePage.jsx"));
const EquivalenciasPage = lazy(() => import("../public/EquivalenciasPage.jsx"));
const QuestionnairePage = lazy(() => import("../public/QuestionnairePage.jsx"));



function App() {


    return (

        <BrowserRouter>
            <Routes>
                <Route exact path="/" element={<>


                    <Navbar2/>
                    <Home/>
                    <Results/>
                    <PlanParaTi/>
                    {/* About y Questions2 ocultos temporalmente */}
                    <QuieresEmpezar/>
                    <CambioForm/>
                    {/* Contact y Prozis ocultos temporalmente */}
                    <Footer/>
                </>}>

                </Route>

                <Route path="/contratar" element={<>
                    <Contratar/>
                    <Contact/>

                </>}/>



                <Route path="/solicitud" element={
                    <Suspense fallback={<div className="min-h-screen bg-bgBlack"/>}>
                        <IntakePage/>
                    </Suspense>
                }/>

                <Route path="/equivalencias" element={
                    <Suspense fallback={<div className="min-h-screen bg-bgBlack"/>}>
                        <EquivalenciasPage/>
                    </Suspense>
                }/>

                <Route path="/cuestionario" element={
                    <Suspense fallback={<div className="min-h-screen bg-bgBlack"/>}>
                        <QuestionnairePage/>
                    </Suspense>
                }/>

                <Route path="/admin/*" element={
                    <Suspense fallback={<div className="min-h-screen bg-bgBlack"/>}>
                        <AdminApp/>
                    </Suspense>
                }/>

                <Route path="*" element={<Navigate to="/" replace/>}/>
                <Route path="/calculadorMacros" element={
                    <CalculadorMacros/>

                }/>
            </Routes>
        </BrowserRouter>

    )
}

export default App
